const initState = {
  roles: [],
};

const rolesReducer = (state = initState, action) => {
  switch (action.type) {
    case "FETCH_ROLES":
      return { ...state, roles: action.payload };
      break;

    default:
      return { ...state };

      break;
  }
};

export default rolesReducer;
